import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "../axiosConfig";

const RefuseOffice = () => {
  const { cv_id } = useParams();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get("reason") || "";
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const refuseInterview = async () => {
      try {
        setLoading(true);
        const response = await axios.put(
          `https://api.comnieuthienly.vn/api/refuse-office-interview/${cv_id}`,
          {
            reason: reason || "Không có lý do cụ thể"
          }
        );
        
        if (response.data && (response.data.code === 200 || response.data.success === true)) {
          setLoading(false);
        } else {
          setError("Có lỗi xảy ra khi từ chối phỏng vấn.");
          setLoading(false);
        }
      } catch (err) {
        console.error("Error refusing interview:", err);
        setError(err.response?.data?.msg || "Có lỗi xảy ra khi từ chối phỏng vấn.");
        setLoading(false);
      }
    };

    if (cv_id) {
      refuseInterview();
    }
  }, [cv_id, reason]);

  return (
    <div className="container mx-auto">
      <div
        className="flex flex-col items-center justify-between"
        style={{ height: "100vh" }}
      >
        <div>
          <div className="banner-img card-banner"></div>
          <div className="wrap-body">
            <div className="line"></div>
            <div className="text">
              <div className="text-content">
                {loading ? (
                  <p>Đang xử lý...</p>
                ) : error ? (
                  <p style={{ color: "red" }}>{error}</p>
                ) : (
                  <>
                    <p>
                      Bộ phận Tuyển dụng đã nhận được thông tin từ chối của bạn. 
                      Cảm ơn bạn đã phản hồi về việc không thể tham gia phỏng vấn.
                    </p>
                    <div style={{ height: 10 }}></div>
                    <p>
                      Chúng tôi rất tiếc vì không thể gặp bạn trong buổi phỏng vấn này. 
                      Nếu trong tương lai bạn có cơ hội và quan tâm đến các vị trí tuyển dụng 
                      của Công ty, chúng tôi rất mong được hợp tác với bạn.
                    </p>
                    {reason && (
                      <p style={{ marginTop: "15px", fontStyle: "italic" }}>
                        Lý do: {reason}
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <a
          className="style-link flex flex-row items-center justify-center"
          href="https://comnieuthienly.vn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            style={{
              aspectRatio: "auto 74 / 24",
              width: "200px",
            }}
            src="https://i.imgur.com/nB8LOLM.png"
            alt="img-logo-thien-ly"
          />
        </a>
      </div>
    </div>
  );
};

export default RefuseOffice;

